import { render, staticRenderFns } from "./ExpertCertification.vue?vue&type=template&id=5f63ee95&scoped=true&"
import script from "./ExpertCertification.vue?vue&type=script&lang=js&"
export * from "./ExpertCertification.vue?vue&type=script&lang=js&"
import style0 from "./ExpertCertification.vue?vue&type=style&index=0&id=5f63ee95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f63ee95",
  null
  
)

export default component.exports